import axios from "axios";
import { convertObjectToUrlParams } from "../helpers/convertObjToUrlParams";

export interface Unsubmitted {
  organizationID?: number;
  beginDate?: string;
  endDate?: string;
  tripTypeID?: number;
  excludeCrewSubmitted?: boolean;
}

export const getUnsubmittedReport = async (params: Unsubmitted) => {
  try {
    const response = await axios.get(
      `${
        process.env.REACT_APP_API
      }/Report/Unsubmitted${convertObjectToUrlParams(params)}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
